import React from 'react';
import { connect } from 'react-redux'

import UpgradeAccount from 'components/auth/upgrade-account'

import {
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

const ModalUpgrade = props => {
    const {
        userData,
        accountData,
        closeCallback,
        setLoading
    } = props

    let title 
    
    if(accountData.isPremium || accountData.onTrial){
        title = 'Edit billing details'
    }else if(accountData.has_had_trial_already){
        title = 'Resume Hassl'
    }else{
        title = 'Upgrade your plan'
    }

    return (
        <div>
            <h2>
                { title }
            </h2>
            <div className={'borders'}>
                <UpgradeAccount
                    setLoading={setLoading}
                    isNew={false}
                    userData={userData}
                    accountData={accountData}
                    closeCallback={closeCallback}
                />
            </div>
        </div>
    );
};

const mapStateToProps = state => {
	return {
		accountData: getCurrentAccount(state),
		userData: getCurrentUser(state),
	}
}

export default connect(mapStateToProps, {})(ModalUpgrade)
